import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NotFoundPage from "./ErrorPage/NotFoundPage.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "./public/css/main.css";
import Forbidden from "./ErrorPage/ForbiddenErrorPage.jsx";
import ServerError from "./ErrorPage/ServerErrorPage.jsx";
import PaymentTutorialPage from "./Websites/PaymentTutorialPage.jsx";
import App from './App.jsx';
import LandingPages from './Pages/LandingPages.jsx';
import LoginMasterPages from './Pages/Auth/LoginMasterPages.jsx';
import DashboardPages from './Pages/DashboardPages.jsx';
import ResetPassword from './Pages/Auth/ResetPassword.jsx';
import ForgotPages from './Pages/Auth/ForgotPages.jsx';
import { AuthValidation } from './Service/API/Auth/AuthValidation.jsx';
import RegisterPages from './Pages/Auth/RegisterPages.jsx';
import RegisterNewPages from './Pages/Auth/RegisterNewPages.jsx';

createRoot(document.getElementById("root")).render(
     <BrowserRouter>
       <Routes>
          <Route
            path="/"
            element={
            <>
              {/* <AuthValidation /> */}
              <App/>
            </>
          }
          >
            <Route
              path="/*"
              element={<NotFoundPage/>}
            ></Route>
            <Route
              path="/"
              element={<LandingPages/>}
            ></Route>
            <Route
              path="/home"
              element={
                <>
                  <AuthValidation />
                  <DashboardPages/>
                </>
              }
            ></Route>
            <Route
              path='/login'
              element={<LoginMasterPages/>}
            />
            <Route
              path='/register'
              element={<RegisterPages/>}
            />
            <Route
              path='/register/new'
              element={<RegisterNewPages/>}
            />
            <Route
              path='/forgot'
              element={<ForgotPages/>}
            />
            <Route
              path='/reset'
              element={<ResetPassword/>}
            />
            <Route
              path="/403"
              element={<Forbidden/>}
            ></Route>
            <Route
              path="/500"
              element={<ServerError/>}
            ></Route>
            <Route
              path="/cara-bayar"
              element={<PaymentTutorialPage/>}
            ></Route>
          </Route>
        </Routes>
    </BrowserRouter>
);
